import { keys } from './keys';

export const en = {
  [keys.buttonAddFile]: 'Add file',
};
